var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlltelLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 117.893,
    height: 44.614,
    viewBox: "0 0 117.893 44.614",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa8329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe235e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.5,
    x2: 0.539,
    y2: 1.23,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1056d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30a3f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alltel-logo-update",
    transform: "translate(-89 -14.984)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AV4-2022",
    transform: "translate(89 14.984)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M1652.437,1687.375v36.658a3.684,3.684,0,1,0,7.368,0v-36.658a3.684,3.684,0,1,0-7.368,0Z",
    transform: "translate(-1541.913 -1683.68)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M1603.485,1687.375v36.658a3.684,3.684,0,1,0,7.368,0v-36.658a3.684,3.684,0,1,0-7.368,0Z",
    transform: "translate(-1555.884 -1683.68)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    d: "M1598.662,1683.68a3.69,3.69,0,0,0-3.684,3.7v36.658a3.684,3.684,0,1,0,7.368,0v-36.658a3.69,3.69,0,0,0-3.684-3.7",
    transform: "translate(-1558.311 -1683.68)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    d: "M1619.359,1715.078v-12.693h4.026a3.639,3.639,0,0,0,2.25-.788,3.694,3.694,0,0,0-2.25-6.6h-4.026v-5.307a3.683,3.683,0,1,0-7.366,0v25.39a11.985,11.985,0,0,0,11.029,11.943,3.463,3.463,0,0,0,.363.037,3.693,3.693,0,0,0,.039-7.386A4.636,4.636,0,0,1,1619.359,1715.078Z",
    transform: "translate(-1553.457 -1683.009)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16613",
    "data-name": "Group 16613",
    transform: "translate(0 11.446)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M1580.783,1713.593a6.651,6.651,0,1,0-6.629-6.651A6.639,6.639,0,0,0,1580.783,1713.593Z",
    transform: "translate(-1564.254 -1690.308)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    d: "M1566.452,1709.136a16.575,16.575,0,0,0,16.532,16.582,16.347,16.347,0,0,0,4.763-.72,3.7,3.7,0,0,0,.562-7.112,3.459,3.459,0,0,0-2.452-.027c-.036.013-.074.023-.111.035a9.072,9.072,0,0,1-2.762.435,9.193,9.193,0,1,1,9.163-9.193v12.323a3.683,3.683,0,1,0,7.366,0v-12.53a16.531,16.531,0,0,0-33.062.207Z",
    transform: "translate(-1566.452 -1692.552)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    d: "M1632.155,1705.468a9.091,9.091,0,0,1,16.658,0Zm8.33-12.838a16.537,16.537,0,0,0-4.443,32.451v0l.07.016a16.371,16.371,0,0,0,2.189.445c.048.008.1.014.143.019a16.333,16.333,0,0,0,12.875-3.945l.123-.111q.322-.287.628-.594c.024-.021.047-.046.072-.07.054-.055.112-.109.167-.165.029-.033.062-.06.09-.093l0,0c.07-.075.138-.155.209-.23a3.789,3.789,0,0,0,.347-.528,3.688,3.688,0,0,0-3.239-5.472,3.661,3.661,0,0,0-2.243.779,3.6,3.6,0,0,0-.348.29c-.026.023-.047.053-.071.078-.194.2-.4.4-.61.577-.064.057-.128.107-.193.159-.131.109-.264.212-.4.311-.113.083-.226.164-.342.24-.058.041-.12.076-.179.114a9.191,9.191,0,0,1-3.328,1.268l-.247.038c-.156.021-.311.044-.465.055-.235.02-.471.034-.708.036-.151,0-.3,0-.456-.008-.068,0-.138,0-.2-.008-.143-.01-.286-.022-.428-.039l-.238-.027c-.136-.02-.272-.045-.409-.068-.083-.015-.166-.029-.25-.047-.13-.028-.26-.062-.391-.1a9.162,9.162,0,0,1-6.044-5.147h21.167a3.677,3.677,0,0,0,3.636-3.443c.007-.086.025-.163.025-.251s-.018-.157-.023-.239a16.524,16.524,0,0,0-16.475-16.3Z",
    transform: "translate(-1550.027 -1681.083)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlltelLogo);
export default __webpack_public_path__ + "static/media/alltel-logo.959c2d47d8c602b802bc1733148d8562.svg";
export { ForwardRef as ReactComponent };